import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import createModel from '../utils/models';
import _ from 'lodash';
/**
 * Custom Redux Model
 * @param {Object}
 * @constructor
 */

var Model = function Model(_ref) {
  var modelName = _ref.modelName,
      _ref$actionCreators = _ref.actionCreators,
      actionCreators = _ref$actionCreators === void 0 ? {} : _ref$actionCreators,
      _ref$selectors = _ref.selectors,
      selectors = _ref$selectors === void 0 ? {} : _ref$selectors,
      _ref$initialState = _ref.initialState,
      initialState = _ref$initialState === void 0 ? {} : _ref$initialState,
      namespace = _ref.namespace;

  _classCallCheck(this, Model);

  return createModel({
    modelName: modelName,
    initialState: _.merge({}, Model.initialState, initialState),
    selectors: selectors,
    actionCreators: actionCreators,
    namespace: namespace
  });
};

_defineProperty(Model, "initialState", {});

export { Model as default };